module.exports = __webpack_public_path__ + "static/img/default.e8b20ff8.png";